import { render, staticRenderFns } from "./TheMarketsInfo.vue?vue&type=template&id=70ea91d6&scoped=true"
import script from "./TheMarketsInfo.vue?vue&type=script&lang=js"
export * from "./TheMarketsInfo.vue?vue&type=script&lang=js"
import style0 from "./TheMarketsInfo.vue?vue&type=style&index=0&id=70ea91d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea91d6",
  null
  
)

export default component.exports